/**
 * 拓扑插件-模块标识常量定义
 */
export default {
  // 组件模块
  componentInfo: 'COMPONENT_INFO',
  // 组件模块监视器
  componentInfoJob: 'COMPONENT_INFO_JOB',
  // 常规图形
  generalGraphics: 'GENERAL_GRAPHICS',
  // 图片素材
  pictureMaterial: 'PICTURE_MATERIAL',
  // 文字素材
  textMaterial: 'TEXT_MATERIAL',
  // 背景图片
  backgroundPicture: 'BACKGROUND_PICTURE'
};
